import { render, staticRenderFns } from "./StatusWidget.vue?vue&type=template&id=3c163aa4&scoped=true&"
import script from "./StatusWidget.vue?vue&type=script&lang=js&"
export * from "./StatusWidget.vue?vue&type=script&lang=js&"
import style0 from "./StatusWidget.vue?vue&type=style&index=0&id=3c163aa4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c163aa4",
  null
  
)

export default component.exports